import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';


export class Group extends BaseModel implements Deserializable {

  groupId: number;
  ownerUid: string;
  name: string;
  description: string;

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    return this;
  }
}
